import React from "react";
import { Card, Row, Col, OverlayTrigger, Tooltip, Placeholder } from "react-bootstrap";
import { formatThousand } from "@revbox/helpers-fe";
import { auctionCreditBalanceCardLabels } from "@revbox/localization";
import { useCookiesContext } from "../../../contexts/CookiesContext";
import { OverlayContainer } from "../../../services/currency/RenderTooltip";
import { useEurUsdRate } from "../../../hooks/useEurUsdRate";

const DEFAULT_AUTOTOPUP_USD = 150;

export default function DefaultAuctionCreditBalanceCard(props) {
  const { campaign, isIframe, id } = props;
  const { getLanguageAbbr } = useCookiesContext();
  const languageAbbr = getLanguageAbbr();
  const multilang = auctionCreditBalanceCardLabels[languageAbbr];
  const { rate } = useEurUsdRate();

  // Ранній вихід: якщо даних ще немає — рендеримо скелетон і уникаємо зайвих обчислень
  if (!campaign) {
    return (
      <Placeholder
        as={Card.Title}
        animation="glow"
        style={{ color: "var(--bs-body-color)" }}
      >
        <Placeholder style={{ height: 145, width: "100%" }} />
      </Placeholder>
    );
  }

  const showTooltip = Boolean(campaign?.ppc_active || campaign?.ppc_paused);
  const totalCredits =
    (campaign?.ppc_paid_credits ?? 0) + (campaign?.ppc_free_credits ?? 0);
  const amount = Number(Number(totalCredits).toFixed(2));

  const cardClassName = `card-one ${isIframe ? "iframe-card-background" : ""}`;

  const card = (
    <Card className={cardClassName} id={id}>
      <Card.Body>
        <Row>
          <Col xs="12">
            <h3 className="card-value mb-0 flex justify-content-between">
              <OverlayContainer amount={amount} rate={rate}>
                <b>${formatThousand(amount)}</b>
              </OverlayContainer>
            </h3>
            <label className="card-title fw-medium text-dark mb-1">
              {multilang.title}
            </label>
          </Col>
        </Row>
      </Card.Body>

      <Card.Footer
        style={{
          height: "60px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Row>
          <Col xs="12">
            <div
              className="fs-11 text-secondary lh-4"
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              {multilang.autoTopup}
              <OverlayContainer amount={DEFAULT_AUTOTOPUP_USD} rate={rate}>
                <span
                  className="d-block fs-11 text-secondary"
                  style={{ maxWidth: "max-content" }}
                >
                  ${formatThousand(DEFAULT_AUTOTOPUP_USD)}
                </span>
              </OverlayContainer>
            </div>
          </Col>
        </Row>
      </Card.Footer>
    </Card>
  );

  return showTooltip ? (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip placement="bottom">{multilang.tooltip}</Tooltip>}
    >
      {card}
    </OverlayTrigger>
  ) : (
    card
  );
}
